import { z } from 'zod';
import { ResourceId, UnixTimestamp } from '../types/branded';
import { ExtensibleFieldsSchema } from '../types/extensible';

export const ResourceSchema = z.object({
  resourceId: ResourceId,
  type: z.string().min(1),
  roles: z.array(z.string().min(1)).default([]),
  externalId: z.string().min(1).optional(),
  updatedAt: UnixTimestamp,
  ext: ExtensibleFieldsSchema.optional(),
});
export type Resource = z.infer<typeof ResourceSchema>;
